import { makeStyles } from 'tss-react/mui';

const useStylesActionBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  actionBlockInline: {
    marginLeft: 10,
  },
  actionBlockContainerColumn: {
    marginTop: 5,
  },
  textBlockLabel: {
    whiteSpace: 'nowrap',
    marginLeft: 10,
  },
  textBlockLabelMultiline: {
    whiteSpace: 'normal',
  },
  button: {
    whiteSpace: 'nowrap',
    marginLeft: '10px !important',
  },
}));

export default useStylesActionBlock;
